function PisVariablesController(stateService, userService, $uibModal) {
  const ctrl = this;

  ctrl.$onInit = async () => {
    let selectedWorkspace = stateService.getSelectedWorkspace();
    ctrl.workspaceId = selectedWorkspace.id;
    ctrl.isLocked = selectedWorkspace.deployable;
    ctrl.variables = [];
    ctrl.variablesIncludeUser = false;
    getWorkspaceVariables(ctrl.workspaceId);
    ctrl.sortType = 'name'; // set the default sort type
    ctrl.sortReverse = false; // set the default sort order
    ctrl.stateDropdownOpen = false;
    ctrl.hasCommit = userService.hasCommitPIS();
    ctrl.hasEdit = userService.hasEditPIS();
  };

  ctrl.setSortType = column => {
    ctrl.sortType = column;
  };

  ctrl.setSortReverse = () => {
    ctrl.sortReverse = !ctrl.sortReverse;
  };

  ctrl.openCreateModal = async($event, variables) => {
    $event.preventDefault();
    $event.stopPropagation();
    let modalInstance = $uibModal.open({
      component: 'createVariableModal',
      backdrop: 'static',
      resolve: {
        variables: function () {
          return variables;
        },
      },
    });
    modalInstance.result.then(
      variable => {
        let variableObject = Object.assign({}, variable);
        stateService.createVariable(ctrl.workspaceId, variableObject).then((response) => {
          getWorkspaceVariables(ctrl.workspaceId);
        });
      },
      () => {
        // User pressed 'Cancel' in the modal, do nothing.
      }
    );
  };

  ctrl.openDeleteModal = async($event, variable) => {
    $event.preventDefault();
    $event.stopPropagation();
    let modalInstance = $uibModal.open({
      component: 'deleteVariableModal',
      backdrop: 'static',
      resolve: {
        variable: function () {
          return variable;
        },
      },
    });
    modalInstance.result.then(
      variable => {
        stateService.deleteVariable(ctrl.workspaceId, variable).then((response) => { 
          getWorkspaceVariables(ctrl.workspaceId);
        });
      },
      () => {
        // User pressed 'Cancel' in the modal, do nothing.
      }
    );
  };

  const getWorkspaceVariables = (wpId) => {
    ctrl.dataLoading = true;
    stateService.getWorkspaceVariables(wpId).then(
      function(variables) {
        ctrl.variables = variables.filter(function(variable) {
          return variable.type === 'user';
        });
        ctrl.variablesIncludeUser = ctrl.variables.find(v => v.type === 'user') !== null;
        ctrl.dataLoading = false;
      },
      function(error) {
        console.error(error);
        //toasterService.error('toaster.edit-account', 'toaster.edit-account-failure');
      }
    );
  };
};

angular
  .module('pis-tool.module')
  .controller('PisVariablesController', PisVariablesController);